// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_fb-0";
export var headerCellHover = "_fb-1";
export var readCellContainer = "_fb-2";
export var unreadIndicator = "_fb-3";